import React from 'react'
import R from 'ramda'
import { fromNullable, Just, Nothing } from 'data.maybe'

const createCellEditor = Comp => {
  class CellEditor extends React.Component {
    constructor(props) {
      super(props)
      this._commitEdit = this._commitEdit.bind(this)
      this._onEdit = this._onEdit.bind(this)
      this._keyDown = this._keyDown.bind(this)
      this.state = {
        editContent: '',
      }
    }

    componentDidMount() {
      this.previous = window.document.activeElement
      if (this.input && this.input.focus) {
        this.input.focus()
      }
      const { initialValue, editWithValue } = this.props
      if (!R.isNil(initialValue) && !R.isEmpty(initialValue) && editWithValue) {
        this.setState({ editContent: initialValue })
      }
    }

    componentWillUnmount() {
      this.previous.focus()
    }

    _commitEdit(value) {
      /***
       * value maybe passed down... since setState is async editingContet may not be
       * value is possible to be event from blur
       * up-to-date when commitEdit is called. This is specially visible by editors
       * that edit only with 1 user action.
       * for inputs this is not a problem
       */
      const { commitEdit, onEdit, columnIndex, rowIndex } = this.props
      if (commitEdit) {
        // edit contect controlled by upper container
        if (!onEdit) {
          const { editContent } = this.state

          commitEdit({
            editContent: fromNullable(value)
              .chain(v => (typeof v === 'object' ? Nothing() : Just(v)))
              .getOrElse(editContent),
            rowIndex,
            columnIndex,
          })
        } else {
          commitEdit()
        }
      }
    }

    _keyDown(e) {
      const { cancelEdit, onEdit } = this.props
      /** escape **/
      if (e.keyCode === 27 && !onEdit) {
        cancelEdit()
        e.preventDefault()
        e.stopPropagation()
      }
      /** enter **/
      if (e.keyCode === 13 || (e.keyCode === 9 && !onEdit)) {
        this._commitEdit()
        e.preventDefault()
        e.stopPropagation()
      }
    }

    _onEdit(editContent) {
      this.setState({ editContent })
    }

    render() {
      const { keyDown, onEdit, editContent, ...rest } = this.props
      return (
        <Comp
          {...rest}
          {...{
            keyDown: keyDown || this._keyDown,
            onEdit: onEdit || this._onEdit,
            editContent: R.isNil(editContent)
              ? this.state.editContent
              : editContent,
            commitEdit: this._commitEdit,
          }}
          onBlur={this._commitEdit}
          refBinder={n => (this.input = n)}
        />
      )
    }
  }

  return CellEditor
}

export default createCellEditor
